/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `public` - Public
 * * `restricted` - Restricted
 * * `personal` - Personal
 */
export enum AccessTypeEnum {
    PUBLIC = 'public',
    RESTRICTED = 'restricted',
    PERSONAL = 'personal',
}
